import { render, staticRenderFns } from "./PosVouchers.vue?vue&type=template&id=5f20395b"
import script from "./PosVouchers.vue?vue&type=script&lang=js"
export * from "./PosVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports